export function HeroHolocronAnimation() {
  return (
    <div className="home-hero-animation holocron-field" aria-hidden="true">
      <div className="holocron-grid" />
      <div className="holocron-scanlines" />
      <div className="holocron-orbit holocron-orbit--outer" />
      <div className="holocron-orbit holocron-orbit--inner" />
      <div className="holocron-artifact">
        <div className="holocron-core" />
        <div className="holocron-pyramid holocron-pyramid--back" />
        <div className="holocron-pyramid holocron-pyramid--left" />
        <div className="holocron-pyramid holocron-pyramid--right" />
        <div className="holocron-pyramid holocron-pyramid--front" />
        <div className="holocron-rune holocron-rune--one" />
        <div className="holocron-rune holocron-rune--two" />
        <div className="holocron-rune holocron-rune--three" />
      </div>
      <div className="holocron-shade" />
    </div>
  );
}
